import Typography from "@mui/material/Typography";
import { GridOverlay } from "@mui/x-data-grid-pro";
import { useTranslation } from "react-i18next";

/**
 * The empty-grid overlay for a grid whose source failed, so an error never reads as "no rows".
 * The page's error alert carries the detail.
 */
export function LoadFailedOverlay() {
  const { t } = useTranslation();
  return (
    <GridOverlay>
      <Typography color="error">{t("common.gridLoadFailed")}</Typography>
    </GridOverlay>
  );
}
